import React from 'react';
import PropTypes from 'prop-types';

import { userInfoInitState, userInfoReducer } from './Reducer';

export const UserInfoStore = React.createContext(null);

export const UserInfoProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(
    userInfoReducer,
    userInfoInitState
  );

  return (
    <UserInfoStore.Provider value={{ state, dispatch }}>
      {children}
    </UserInfoStore.Provider>
  )
};

UserInfoProvider.propTypes = {
  children: PropTypes.element.isRequired
}